export const getSlots = (item) => {
  const slots = [];
  for (const key in item) key.includes('slot') && !!item[key] && slots.push(item[key]);
  return slots;
};
